import { render } from "./HomePageInformazioni.vue?vue&type=template&id=02a33448"
import script from "./HomePageInformazioni.vue?vue&type=script&lang=js"
export * from "./HomePageInformazioni.vue?vue&type=script&lang=js"

import exportComponent from "D:\\documenti\\Lavoro\\Niemit\\com.niemit.cortebenedetto\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__